<template>
    <div class="detail">
        <div class="detail__header">
            <DetailHeader v-for="(unit,index) in selectedUnits" :unit="unit" :color="colors[index]" :configItem="false" :firstItem="(index === 0) ? true : false" />
            <div class="detail-map">
                <div class="detail-map__panel">
                    <div class="detail-map__panel__header">{{ $t('detail.map') }}</div>
                    <div class="detail-map__panel__content">
                        <MglMap v-if="this.startingCoords"
                                class="detail-map__panel__content__canvas"
                                :trackResize="true"
                                :attributionControl="false"
                                :accessToken="accessToken"
                                :mapStyle="mapStyle"
                                :center="this.startingCoords"
                                :maxZoom="maxZoom"
                                :minZoom="minZoom"
                                :zoom="zoom"
                                @load="mapLoaded">
                            <MglMarker v-for="(unit, index) in selectedUnits" v-if="unit.lat && unit.lon" :coordinates="[unit.lon, unit.lat]" :color="colors[index]+65">
                                <MglPopup :closeButton="false">
                                        <div class="map-popup">
                                            <h3>{{ $t('map.calculated') }}</h3>
                                            <span>Device ID: {{ unit.external.toUpperCase() }}</span>
                                        </div>
                                </MglPopup>
                            </MglMarker>
                            <MglMarker v-for="(unit, index) in selectedUnits" v-if="unit.manualLat && unit.manualLon" :coordinates="[unit.manualLon, unit.manualLat]" :color="colors[index]">
                                <MglPopup :closeButton="false">
                                        <div class="map-popup">
                                            <h3>{{ $t('map.manual') }}</h3>
                                            <span>Device ID: {{ unit.external.toUpperCase() }}</span>
                                        </div>
                                </MglPopup>
                            </MglMarker>

                            <MglFullscreenControl position="top-right" ></MglFullscreenControl>
                            <MglNavigationControl position="top-right" ></MglNavigationControl>
                        </MglMap>
                    </div>
                </div>
            </div>
        </div>
        <div class="detail__charts">
            <div class="detail__charts__wrapper">
                <DetailChartPanel v-for="sensorType in sensorID" :loadedData="chartData" :key="sensorType.type" :sensorType="sensorType" :unit="selectedUnits[0]"/>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DetailHeader from '@/views/detail/DetailHeader.vue';
import DetailChartPanel from '@/views/bulk-detail/DetailChartPanel.vue';
import 'mapbox-gl/dist/mapbox-gl.css';
import 'vue-mapbox/dist/vue-mapbox.css';
import Mapbox from "mapbox-gl";
import {
	MglMap,
	MglPopup,
	MglMarker,
	MglNavigationControl,
	MglFullscreenControl
} from "vue-mapbox";


export default {
	name: 'bulk-detail',
	components: {
		DetailHeader,
		DetailChartPanel,
		MglMap,
		MglMarker,
		MglPopup,
		MglNavigationControl,
		MglFullscreenControl
	},
	data() {
		return {
			colors: ['#b2de4d', '#64b5f6', '#ffb74d', '#f47f7f', '#a1887f', '#7da453', '#2286c3', '#c75b39', '#af4448', '#725b53'],
			chartData: [],
			sensorID: [],
			maxZoom: 17,
			minZoom: 2,
			zoom: 0,
			SOIL_3XS: 1,
			showTimSen: false,
			accessToken: 'pk.eyJ1IjoidGVudGFjbGVzaW5ub3ZhdGlvbiIsImEiOiJja2hlbHNxdmwwMzJjMnhud3k4c2hld2IwIn0.SjwZrqM8oorcsOJW9WppBw', // your access token. Needed if you using Mapbox maps
			mapStyle: 'mapbox://styles/mapbox/streets-v11'
		};
	},
	created() {
		this.chartData.push({
			id: '',
			name: '',
			unit: '',
			values: null,
		});

		this.selectedUnits.forEach((tentacle) => {
			tentacle.sensors.forEach((sensor) => {
				let sensorItem = this.sensorID.find(item => item.type === sensor.sensorId);
				if (!sensorItem) {
					sensorItem = {
						type: sensor.sensorId,
						name: sensor.name,
						id: [],
						minValue: sensor.min,
						maxValue: sensor.max,
						unit: sensor.unit,
					};
					this.sensorID.push(sensorItem);
				}
				sensorItem.id.push(sensor.id);
			});
		});

		this.setChartData(this.getDateFromToday(0, -1, 0), this.getDateFromToday(0, 0, 0));
	},
	computed: {
		...mapGetters('tentacle', ['type', 'units']),
		selectedIds() {
			return this.$route.query.ids.split(',').map(Number);
		},
		selectedUnits() {
			return this.units.filter(item => this.selectedIds.includes(item.id));
		},
        startingCoords() {
			for (let i = 0; i < this.selectedUnits.length; i += 1) {
				if (this.selectedUnits[i].lat !== null && this.selectedUnits[i].lon !== null){
					return {lat: this.selectedUnits[i].lat, lon: this.selectedUnits[i].lon};
				}
			}

			return false;
        }
	},
	methods: {
		mapLoaded(e) {
			// in component
			this.map = e.map;
			let coordCollection = [];
			let boundOne = null;
			let boundTwo = null;

			for (let i = 0; i < this.selectedUnits.length; i += 1) {
				if (this.selectedUnits[i].lat !== null && this.selectedUnits[i].lon !== null){
					if (boundOne === null) {
						boundOne = {lat: this.selectedUnits[i].lat, lon: this.selectedUnits[i].lon};
					} else {
						if (boundOne.lat < this.selectedUnits[i].lat) {
							boundOne.lat = this.selectedUnits[i].lat;
						}
						if ( boundOne.lon < this.selectedUnits[i].lon) {
							boundOne.lon = this.selectedUnits[i].lon;
						}
					}
					if (boundTwo === null){
						boundTwo = {lat: this.selectedUnits[i].lat, lon: this.selectedUnits[i].lon};
					} else {
						if (boundTwo.lat > this.selectedUnits[i].lat) {
							boundTwo.lat = this.selectedUnits[i].lat;
						}
						if ( boundTwo.lon > this.selectedUnits[i].lon) {
							boundTwo.lon = this.selectedUnits[i].lon;
						}
					}
					coordCollection = [boundOne, boundTwo];
                }
			}

			this.map.fitBounds(coordCollection, {
				padding: {top: 50, bottom: 50, left: 50, right: 50},
                maxZoom: 15
			});
		},
		goBack() {
			this.$router.push({
				name: 'dashboard',
				params: {
					lang: this.$i18n.locale.toLowerCase(),
					type: this.type.urlSlug,
				},
			});
		},
		getDateFromToday(year, month, day) {
			return `${new Date().getFullYear() + year}-${new Date().getMonth() + 1 + month}-${new Date().getDate() + day}`;
		},
		setChartData(fromDate, toDate) {
			const filter = [];
			for (let i = 0; i < this.selectedUnits.length; i += 1) {
				for (let j = 0; j < this.selectedUnits[i].sensors.length; j += 1) {
					filter.push({id: this.selectedUnits[i].sensors[j].id, from: fromDate, to: toDate});
				}
			}
			const data = {
			    filter: filter,
                tentacle: this.selectedUnits[0].id
            };

			this.$store.dispatch('tentacle/setMeasurement', data).then((resolve) => {
				let data = [];
				if (resolve.data[0]) {
					data = resolve.data;
				}
				this.chartData = data;
			});
		},
	},
};
</script>
<style>
    canvas.mapboxgl-canvas {
        outline: none;
        border: 0.5px solid rgba(172, 180, 197, 0.31);
        border-top: none;
        border-radius: 0 0 2rem 2rem;
    }

    .mapboxgl-popup-content {
        padding: 5px;
    }

    .map-popup > h3 {
        margin-top: -1px;
        margin-bottom: 2px;
    }
</style>

<style lang="scss" scoped>
    .detail-map {
        margin-top: 2rem;
        padding-left: 8rem;
        @media only screen and (max-width: 1199px) {
            padding-left: 0;
            width: 90%;
            margin-right: auto;
            margin-left: 5%;
        }

        &__panel {
            margin-bottom: 4rem;
            border-radius: 2rem;
            background-color: #fff;
            box-shadow: 0 0 5px rgba(100, 116, 160, 0.1);
            position: relative;
            .loading-wrapper {
                position: absolute;
                top: 5rem;
                width: 100%;
                height: calc(100% - 10rem);
                background-color: rgba(255, 255, 255, 0.8);
                display: flex;
                align-items: center;
                justify-content: center;
                z-index: 2;
            }
            &__header {
                padding: 0 3rem;
                height: 6rem;
                border-bottom: 0.1rem solid #eee;
                display: flex;
                align-items: center;
                font-weight: 600;
                font-size: 1.4rem;
                color: $grey;
            }

            &__content {
                min-height: 42rem;
                @media only screen and (max-width: 1199px) {
                    min-height: 26rem;
                }

                &__canvas {
                    height: 42rem;
                    border-radius: 0 0 2rem 2rem;
                    overflow: hidden;
                }
            }
        }
    }
    .detail {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-column-gap: 4rem;
        @media only screen and (max-width: 1199px) {
            grid-template-columns: 1fr;
            grid-column-gap: 0;
            padding-bottom: 5em;
        }
        &__back {
            display: flex;
            align-items: center;
            width: max-content;
            margin-left: 5% ;
            display: flex;
            justify-content: center;
            cursor: pointer;
            color:gray;
            fill:gray;
        }

        &__header {
            margin-top: 2em;
            grid-column: 1/2;
            @media only screen and (max-width: 1199px) {
                width: 100vw;
                grid-template-columns: 1fr;
                grid-column-gap: 0;
            }
            @media only screen and (min-width: 992px) and (max-width: 1199px) {
                width: calc(100% - 2em);
            }
        }

        &__charts {
            width: 100%;
            grid-column: 2/4;
            &__wrapper {
                padding-top: 6em;
                padding-right: 8rem;
            }
            @media only screen and (max-width: 1199px) {
                width: 100vw;
                grid-column: 1/1;
                &__wrapper {
                    padding-top: 0em;
                    padding-right: 0;
                }
            }
            @media only screen and (min-width: 992px) and (max-width: 1199px) {
                width: calc(100% - 2em);
            }
        }
}
</style>
